export const stockData = [
  {
    stock_item: {
      category_name: "Electronics",
      item_name: "Laptop Dell XPS 13",
      stock_item_id: "101"
    },
    grandOpeningData: {
      stock_item_id: "101",
      quantity: "5",
      rate: 45000,
      value: 225000,
      total_nos_box: "5"
    },
    grandInwardData: {
      stock_item_id: "101",
      quantity: "12",
      rate: 44000,
      value: 528000,
      total_nos_box: "12"
    },
    grandOutwardData: {
      stock_item_id: "101",
      quantity: "8",
      rate: 48000,
      value: 384000,
      consumption_value: 352000,
      gross_profit: 32000,
      profit_per: 8.33,
      total_nos_box: "8"
    },
    grandClosingData: {
      stock_item_id: "101",
      quantity: "9",
      rate: 44000,
      value: 396000,
      total_nos_box: "9"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "101",
          quantity: "3",
          rate: 45000,
          value: 135000,
          total_nos_box: "3"
        },
        grandInwardData: {
          stock_item_id: "101",
          quantity: "8",
          rate: 44000,
          value: 352000,
          total_nos_box: "8"
        },
        grandOutwardData: {
          stock_item_id: "101",
          quantity: "5",
          rate: 48000,
          value: 240000,
          gross_value: 240000,
          total_nos_box: "5",
          consumption_value: 220000,
          gross_profit: 20000,
          profit_per: 8.33
        },
        grandClosingData: {
          stock_item_id: "101",
          quantity: "6",
          rate: "44000.00",
          value: 264000,
          total_nos_box: "6"
        }
      },
      {
        location_id: "2",
        location_name: "North Branch",
        grandOpeningData: {
          stock_item_id: "101",
          quantity: "2",
          rate: 45000,
          value: 90000,
          total_nos_box: "2"
        },
        grandInwardData: {
          stock_item_id: "101",
          quantity: "4",
          rate: 44000,
          value: 176000,
          total_nos_box: "4"
        },
        grandOutwardData: {
          stock_item_id: "101",
          quantity: "3",
          rate: 48000,
          value: 144000,
          gross_value: 144000,
          total_nos_box: "3",
          consumption_value: 132000,
          gross_profit: 12000,
          profit_per: 8.33
        },
        grandClosingData: {
          stock_item_id: "101",
          quantity: "3",
          rate: "44000.00",
          value: 132000,
          total_nos_box: "3"
                }
      },
      {
          location_id: "3",
          location_name: "South Branch",
          grandOpeningData: {
            stock_item_id: "101",
            quantity: "0",
            rate: 45000,
            value: 0,
            total_nos_box: "0"
          },
          grandInwardData: {
            stock_item_id: "101",
            quantity: "0",
            rate: 44000,
            value: 0,
            total_nos_box: "0"
          },
          grandOutwardData: {
            stock_item_id: "101",
            quantity: "0",
            rate: 48000,
            value: 0,
            gross_value: 0,
            total_nos_box: "0",
            consumption_value: 0,
            gross_profit: 0,
            profit_per: 0
          },
          grandClosingData: {
            stock_item_id: "101",
            quantity: "0",
            rate: "44000.00",
            value: 0,
            total_nos_box: "0"
          }
        }
      
    ]
  },
  {
    stock_item: {
      category_name: "Electronics",
      item_name: "iPhone 15 Pro",
      stock_item_id: "102"
    },
    grandOpeningData: {
      stock_item_id: "102",
      quantity: "8",
      rate: 85000,
      value: 680000,
      total_nos_box: "8"
    },
    grandInwardData: {
      stock_item_id: "102",
      quantity: "15",
      rate: 84000,
      value: 1260000,
      total_nos_box: "15"
    },
    grandOutwardData: {
      stock_item_id: "102",
      quantity: "12",
      rate: 90000,
      value: 1080000,
      consumption_value: 1008000,
      gross_profit: 72000,
      profit_per: 6.67,
      total_nos_box: "12"
    },
    grandClosingData: {
      stock_item_id: "102",
      quantity: "11",
      rate: 84000,
      value: 924000,
      total_nos_box: "11"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "102",
          quantity: "5",
          rate: 85000,
          value: 425000,
          total_nos_box: "5"
        },
        grandInwardData: {
          stock_item_id: "102",
          quantity: "10",
          rate: 84000,
          value: 840000,
          total_nos_box: "10"
        },
        grandOutwardData: {
          stock_item_id: "102",
          quantity: "8",
          rate: 90000,
          value: 720000,
          gross_value: 720000,
          total_nos_box: "8",
          consumption_value: 672000,
          gross_profit: 48000,
          profit_per: 6.67
        },
        grandClosingData: {
          stock_item_id: "102",
          quantity: "7",
          rate: "84000.00",
          value: 588000,
          total_nos_box: "7"
        }
      },
      {
        location_id: "2",
        location_name: "North Branch",
        grandOpeningData: {
          stock_item_id: "102",
          quantity: "3",
          rate: 85000,
          value: 255000,
          total_nos_box: "3"
        },
        grandInwardData: {
          stock_item_id: "102",
          quantity: "5",
          rate: 84000,
          value: 420000,
          total_nos_box: "5"
        },
        grandOutwardData: {
          stock_item_id: "102",
          quantity: "4",
          rate: 90000,
          value: 360000,
          gross_value: 360000,
          total_nos_box: "4",
          consumption_value: 336000,
          gross_profit: 24000,
          profit_per: 6.67
        },
        grandClosingData: {
          stock_item_id: "102",
          quantity: "4",
          rate: "84000.00",
          value: 336000,
          total_nos_box: "4"
        }
      },
      {
        location_id: "3",
        location_name: "South Branch",
        grandOpeningData: {
          stock_item_id: "102",
          quantity: "0",
          rate: 85000,
          value: 0,
          total_nos_box: "0"
        },
        grandInwardData: {
          stock_item_id: "102",
          quantity: "0",
          rate: 84000,
          value: 0,
          total_nos_box: "0"
        },
        grandOutwardData: {
          stock_item_id: "102",
          quantity: "0",
          rate: 90000,
          value: 0,
          gross_value: 0,
          total_nos_box: "0",
          consumption_value: 0,
          gross_profit: 0,
          profit_per: 0
        },
        grandClosingData: {
          stock_item_id: "102",
          quantity: "0",
          rate: "84000.00",
          value: 0,
          total_nos_box: "0"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Electronics",
      item_name: "Samsung Galaxy S24",
      stock_item_id: "103"
    },
    grandOpeningData: {
      stock_item_id: "103",
      quantity: "10",
      rate: 75000,
      value: 750000,
      total_nos_box: "10"
    },
    grandInwardData: {
      stock_item_id: "103",
      quantity: "18",
      rate: 74000,
      value: 1332000,
      total_nos_box: "18"
    },
    grandOutwardData: {
      stock_item_id: "103",
      quantity: "15",
      rate: 82000,
      value: 1230000,
      consumption_value: 1110000,
      gross_profit: 120000,
      profit_per: 9.76,
      total_nos_box: "15"
    },
    grandClosingData: {
      stock_item_id: "103",
      quantity: "13",
      rate: 74000,
      value: 962000,
      total_nos_box: "13"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "103",
          quantity: "6",
          rate: 75000,
          value: 450000,
          total_nos_box: "6"
        },
        grandInwardData: {
          stock_item_id: "103",
          quantity: "12",
          rate: 74000,
          value: 888000,
          total_nos_box: "12"
        },
        grandOutwardData: {
          stock_item_id: "103",
          quantity: "10",
          rate: 82000,
          value: 820000,
          gross_value: 820000,
          total_nos_box: "10",
          consumption_value: 740000,
          gross_profit: 80000,
          profit_per: 9.76
        },
        grandClosingData: {
          stock_item_id: "103",
          quantity: "8",
          rate: "74000.00",
          value: 592000,
          total_nos_box: "8"
        }
      },
      {
        location_id: "2",
        location_name: "North Branch",
        grandOpeningData: {
          stock_item_id: "103",
          quantity: "4",
          rate: 75000,
          value: 300000,
          total_nos_box: "4"
        },
        grandInwardData: {
          stock_item_id: "103",
          quantity: "6",
          rate: 74000,
          value: 444000,
          total_nos_box: "6"
        },
        grandOutwardData: {
          stock_item_id: "103",
          quantity: "5",
          rate: 82000,
          value: 410000,
          gross_value: 410000,
          total_nos_box: "5",
          consumption_value: 370000,
          gross_profit: 40000,
          profit_per: 9.76
        },
        grandClosingData: {
          stock_item_id: "103",
          quantity: "5",
          rate: "74000.00",
          value: 370000,
          total_nos_box: "5"
        }
      },
      {
        location_id: "3",
        location_name: "South Branch",
        grandOpeningData: {
          stock_item_id: "103",
          quantity: "0",
          rate: 75000,
          value: 0,
          total_nos_box: "0"
        },
        grandInwardData: {
          stock_item_id: "103",
          quantity: "0",
          rate: 74000,
          value: 0,
          total_nos_box: "0"
        },
        grandOutwardData: {
          stock_item_id: "103",
          quantity: "0",
          rate: 82000,
          value: 0,
          gross_value: 0,
          total_nos_box: "0",
          consumption_value: 0,
          gross_profit: 0,
          profit_per: 0
        },
        grandClosingData: {
          stock_item_id: "103",
          quantity: "0",
          rate: "74000.00",
          value: 0,
          total_nos_box: "0"
        }
              }
      ]
    },
    {
      stock_item: {
        category_name: "Electronics",
        item_name: "MacBook Air M2",
        stock_item_id: "104"
      },
    grandOpeningData: {
      stock_item_id: "104",
      quantity: "6",
      rate: 95000,
      value: 570000,
      total_nos_box: "6"
    },
    grandInwardData: {
      stock_item_id: "104",
      quantity: "12",
      rate: 94000,
      value: 1128000,
      total_nos_box: "12"
    },
    grandOutwardData: {
      stock_item_id: "104",
      quantity: "9",
      rate: 105000,
      value: 945000,
      consumption_value: 846000,
      gross_profit: 99000,
      profit_per: 10.48,
      total_nos_box: "9"
    },
    grandClosingData: {
      stock_item_id: "104",
      quantity: "9",
      rate: 94000,
      value: 846000,
      total_nos_box: "9"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "104",
          quantity: "6",
          rate: 95000,
          value: 570000,
          total_nos_box: "6"
        },
        grandInwardData: {
          stock_item_id: "104",
          quantity: "12",
          rate: 94000,
          value: 1128000,
          total_nos_box: "12"
        },
        grandOutwardData: {
          stock_item_id: "104",
          quantity: "9",
          rate: 105000,
          value: 945000,
          gross_value: 945000,
          total_nos_box: "9",
          consumption_value: 846000,
          gross_profit: 99000,
          profit_per: 10.48
        },
        grandClosingData: {
          stock_item_id: "104",
          quantity: "9",
          rate: "94000.00",
          value: 846000,
          total_nos_box: "9"
        }
      },
      {
        location_id: "2",
        location_name: "North Branch",
        grandOpeningData: {
          stock_item_id: "104",
          quantity: "0",
          rate: 95000,
          value: 0,
          total_nos_box: "0"
        },
        grandInwardData: {
          stock_item_id: "104",
          quantity: "0",
          rate: 94000,
          value: 0,
          total_nos_box: "0"
        },
        grandOutwardData: {
          stock_item_id: "104",
          quantity: "0",
          rate: 105000,
          value: 0,
          gross_value: 0,
          total_nos_box: "0",
          consumption_value: 0,
          gross_profit: 0,
          profit_per: 0
        },
        grandClosingData: {
          stock_item_id: "104",
          quantity: "0",
          rate: "94000.00",
          value: 0,
          total_nos_box: "0"
        }
      },
      {
        location_id: "3",
        location_name: "South Branch",
        grandOpeningData: {
          stock_item_id: "104",
          quantity: "0",
          rate: 95000,
          value: 0,
          total_nos_box: "0"
        },
        grandInwardData: {
          stock_item_id: "104",
          quantity: "0",
          rate: 94000,
          value: 0,
          total_nos_box: "0"
        },
        grandOutwardData: {
          stock_item_id: "104",
          quantity: "0",
          rate: 105000,
          value: 0,
          gross_value: 0,
          total_nos_box: "0",
          consumption_value: 0,
          gross_profit: 0,
          profit_per: 0
        },
        grandClosingData: {
          stock_item_id: "104",
          quantity: "0",
          rate: "94000.00",
          value: 0,
          total_nos_box: "0"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Electronics",
      item_name: "iPad Pro 12.9",
      stock_item_id: "105"
    },
    grandOpeningData: {
      stock_item_id: "105",
      quantity: "8",
      rate: 65000,
      value: 520000,
      total_nos_box: "8"
    },
    grandInwardData: {
      stock_item_id: "105",
      quantity: "15",
      rate: 64000,
      value: 960000,
      total_nos_box: "15"
    },
    grandOutwardData: {
      stock_item_id: "105",
      quantity: "12",
      rate: 72000,
      value: 864000,
      consumption_value: 768000,
      gross_profit: 96000,
      profit_per: 11.11,
      total_nos_box: "12"
    },
    grandClosingData: {
      stock_item_id: "105",
      quantity: "11",
      rate: 64000,
      value: 704000,
      total_nos_box: "11"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "105",
          quantity: "5",
          rate: 65000,
          value: 325000,
          total_nos_box: "5"
        },
        grandInwardData: {
          stock_item_id: "105",
          quantity: "10",
          rate: 64000,
          value: 640000,
          total_nos_box: "10"
        },
        grandOutwardData: {
          stock_item_id: "105",
          quantity: "8",
          rate: 72000,
          value: 576000,
          gross_value: 576000,
          total_nos_box: "8",
          consumption_value: 512000,
          gross_profit: 64000,
          profit_per: 11.11
        },
        grandClosingData: {
          stock_item_id: "105",
          quantity: "7",
          rate: "64000.00",
          value: 448000,
          total_nos_box: "7"
        }
      },
      {
        location_id: "2",
        location_name: "North Branch",
        grandOpeningData: {
          stock_item_id: "105",
          quantity: "3",
          rate: 65000,
          value: 195000,
          total_nos_box: "3"
        },
        grandInwardData: {
          stock_item_id: "105",
          quantity: "5",
          rate: 64000,
          value: 320000,
          total_nos_box: "5"
        },
        grandOutwardData: {
          stock_item_id: "105",
          quantity: "4",
          rate: 72000,
          value: 288000,
          gross_value: 288000,
          total_nos_box: "4",
          consumption_value: 256000,
          gross_profit: 32000,
          profit_per: 11.11
        },
        grandClosingData: {
          stock_item_id: "105",
          quantity: "4",
          rate: "64000.00",
          value: 256000,
          total_nos_box: "4"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Furniture",
      item_name: "Office Chair Ergonomic",
      stock_item_id: "106"
    },
    grandOpeningData: {
      stock_item_id: "106",
      quantity: "20",
      rate: 3500,
      value: 70000,
      total_nos_box: "20"
    },
    grandInwardData: {
      stock_item_id: "106",
      quantity: "35",
      rate: 3400,
      value: 119000,
      total_nos_box: "35"
    },
    grandOutwardData: {
      stock_item_id: "106",
      quantity: "28",
      rate: 4200,
      value: 117600,
      consumption_value: 95200,
      gross_profit: 22400,
      profit_per: 19.05,
      total_nos_box: "28"
    },
    grandClosingData: {
      stock_item_id: "106",
      quantity: "27",
      rate: 3400,
      value: 91800,
      total_nos_box: "27"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "106",
          quantity: "20",
          rate: 3500,
          value: 70000,
          total_nos_box: "20"
        },
        grandInwardData: {
          stock_item_id: "106",
          quantity: "35",
          rate: 3400,
          value: 119000,
          total_nos_box: "35"
        },
        grandOutwardData: {
          stock_item_id: "106",
          quantity: "28",
          rate: 4200,
          value: 117600,
          gross_value: 117600,
          total_nos_box: "28",
          consumption_value: 95200,
          gross_profit: 22400,
          profit_per: 19.05
        },
        grandClosingData: {
          stock_item_id: "106",
          quantity: "27",
          rate: "3400.00",
          value: 91800,
          total_nos_box: "27"
        }
      },
      {
        location_id: "2",
        location_name: "North Branch",
        grandOpeningData: {
          stock_item_id: "106",
          quantity: "0",
          rate: 3500,
          value: 0,
          total_nos_box: "0"
        },
        grandInwardData: {
          stock_item_id: "106",
          quantity: "0",
          rate: 3400,
          value: 0,
          total_nos_box: "0"
        },
        grandOutwardData: {
          stock_item_id: "106",
          quantity: "0",
          rate: 4200,
          value: 0,
          gross_value: 0,
          total_nos_box: "0",
          consumption_value: 0,
          gross_profit: 0,
          profit_per: 0
        },
        grandClosingData: {
          stock_item_id: "106",
          quantity: "0",
          rate: "3400.00",
          value: 0,
          total_nos_box: "0"
        }
      },
      {
        location_id: "3",
        location_name: "South Branch",
        grandOpeningData: {
          stock_item_id: "106",
          quantity: "0",
          rate: 3500,
          value: 0,
          total_nos_box: "0"
        },
        grandInwardData: {
          stock_item_id: "106",
          quantity: "0",
          rate: 3400,
          value: 0,
          total_nos_box: "0"
        },
        grandOutwardData: {
          stock_item_id: "106",
          quantity: "0",
          rate: 4200,
          value: 0,
          gross_value: 0,
          total_nos_box: "0",
          consumption_value: 0,
          gross_profit: 0,
          profit_per: 0
        },
        grandClosingData: {
          stock_item_id: "106",
          quantity: "0",
          rate: "3400.00",
          value: 0,
          total_nos_box: "0"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Furniture",
      item_name: "Wooden Dining Table",
      stock_item_id: "107"
    },
    grandOpeningData: {
      stock_item_id: "107",
      quantity: "6",
      rate: 12000,
      value: 72000,
      total_nos_box: "6"
    },
    grandInwardData: {
      stock_item_id: "107",
      quantity: "10",
      rate: 11800,
      value: 118000,
      total_nos_box: "10"
    },
    grandOutwardData: {
      stock_item_id: "107",
      quantity: "7",
      rate: 15000,
      value: 105000,
      consumption_value: 82600,
      gross_profit: 22400,
      profit_per: 21.33,
      total_nos_box: "7"
    },
    grandClosingData: {
      stock_item_id: "107",
      quantity: "9",
      rate: 11800,
      value: 106200,
      total_nos_box: "9"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "107",
          quantity: "6",
          rate: 12000,
          value: 72000,
          total_nos_box: "6"
        },
        grandInwardData: {
          stock_item_id: "107",
          quantity: "10",
          rate: 11800,
          value: 118000,
          total_nos_box: "10"
        },
        grandOutwardData: {
          stock_item_id: "107",
          quantity: "7",
          rate: 15000,
          value: 105000,
          gross_value: 105000,
          total_nos_box: "7",
          consumption_value: 82600,
          gross_profit: 22400,
          profit_per: 21.33
        },
        grandClosingData: {
          stock_item_id: "107",
          quantity: "9",
          rate: "11800.00",
          value: 106200,
          total_nos_box: "9"
        }
      },
      {
        location_id: "2",
        location_name: "North Branch",
        grandOpeningData: {
          stock_item_id: "107",
          quantity: "0",
          rate: 12000,
          value: 0,
          total_nos_box: "0"
        },
        grandInwardData: {
          stock_item_id: "107",
          quantity: "0",
          rate: 11800,
          value: 0,
          total_nos_box: "0"
        },
        grandOutwardData: {
          stock_item_id: "107",
          quantity: "0",
          rate: 15000,
          value: 0,
          gross_value: 0,
          total_nos_box: "0",
          consumption_value: 0,
          gross_profit: 0,
          profit_per: 0
        },
        grandClosingData: {
          stock_item_id: "107",
          quantity: "0",
          rate: "11800.00",
          value: 0,
          total_nos_box: "0"
        }
      },
      {
        location_id: "3",
        location_name: "South Branch",
        grandOpeningData: {
          stock_item_id: "107",
          quantity: "0",
          rate: 12000,
          value: 0,
          total_nos_box: "0"
        },
        grandInwardData: {
          stock_item_id: "107",
          quantity: "0",
          rate: 11800,
          value: 0,
          total_nos_box: "0"
        },
        grandOutwardData: {
          stock_item_id: "107",
          quantity: "0",
          rate: 15000,
          value: 0,
          gross_value: 0,
          total_nos_box: "0",
          consumption_value: 0,
          gross_profit: 0,
          profit_per: 0
        },
        grandClosingData: {
          stock_item_id: "107",
          quantity: "0",
          rate: "11800.00",
          value: 0,
          total_nos_box: "0"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Furniture",
      item_name: "Sofa Set 3+2+1",
      stock_item_id: "108"
    },
    grandOpeningData: {
      stock_item_id: "108",
      quantity: "4",
      rate: 25000,
      value: 100000,
      total_nos_box: "4"
    },
    grandInwardData: {
      stock_item_id: "108",
      quantity: "8",
      rate: 24500,
      value: 196000,
      total_nos_box: "8"
    },
    grandOutwardData: {
      stock_item_id: "108",
      quantity: "6",
      rate: 32000,
      value: 192000,
      consumption_value: 147000,
      gross_profit: 45000,
      profit_per: 23.44,
      total_nos_box: "6"
    },
    grandClosingData: {
      stock_item_id: "108",
      quantity: "6",
      rate: 24500,
      value: 147000,
      total_nos_box: "6"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "108",
          quantity: "4",
          rate: 25000,
          value: 100000,
          total_nos_box: "4"
        },
        grandInwardData: {
          stock_item_id: "108",
          quantity: "8",
          rate: 24500,
          value: 196000,
          total_nos_box: "8"
        },
        grandOutwardData: {
          stock_item_id: "108",
          quantity: "6",
          rate: 32000,
          value: 192000,
          gross_value: 192000,
          total_nos_box: "6",
          consumption_value: 147000,
          gross_profit: 45000,
          profit_per: 23.44
        },
        grandClosingData: {
          stock_item_id: "108",
          quantity: "6",
          rate: "24500.00",
          value: 147000,
          total_nos_box: "6"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Furniture",
      item_name: "Study Table with Drawer",
      stock_item_id: "109"
    },
    grandOpeningData: {
      stock_item_id: "109",
      quantity: "15",
      rate: 4500,
      value: 67500,
      total_nos_box: "15"
    },
    grandInwardData: {
      stock_item_id: "109",
      quantity: "25",
      rate: 4400,
      value: 110000,
      total_nos_box: "25"
    },
    grandOutwardData: {
      stock_item_id: "109",
      quantity: "20",
      rate: 5800,
      value: 116000,
      consumption_value: 88000,
      gross_profit: 28000,
      profit_per: 24.14,
      total_nos_box: "20"
    },
    grandClosingData: {
      stock_item_id: "109",
      quantity: "20",
      rate: 4400,
      value: 88000,
      total_nos_box: "20"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "109",
          quantity: "15",
          rate: 4500,
          value: 67500,
          total_nos_box: "15"
        },
        grandInwardData: {
          stock_item_id: "109",
          quantity: "25",
          rate: 4400,
          value: 110000,
          total_nos_box: "25"
        },
        grandOutwardData: {
          stock_item_id: "109",
          quantity: "20",
          rate: 5800,
          value: 116000,
          gross_value: 116000,
          total_nos_box: "20",
          consumption_value: 88000,
          gross_profit: 28000,
          profit_per: 24.14
        },
        grandClosingData: {
          stock_item_id: "109",
          quantity: "20",
          rate: "4400.00",
          value: 88000,
          total_nos_box: "20"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Furniture",
      item_name: "Bed Frame Queen Size",
      stock_item_id: "110"
    },
    grandOpeningData: {
      stock_item_id: "110",
      quantity: "8",
      rate: 8500,
      value: 68000,
      total_nos_box: "8"
    },
    grandInwardData: {
      stock_item_id: "110",
      quantity: "15",
      rate: 8400,
      value: 126000,
      total_nos_box: "15"
    },
    grandOutwardData: {
      stock_item_id: "110",
      quantity: "12",
      rate: 11000,
      value: 132000,
      consumption_value: 100800,
      gross_profit: 31200,
      profit_per: 23.64,
      total_nos_box: "12"
    },
    grandClosingData: {
      stock_item_id: "110",
      quantity: "11",
      rate: 8400,
      value: 92400,
      total_nos_box: "11"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "110",
          quantity: "8",
          rate: 8500,
          value: 68000,
          total_nos_box: "8"
        },
        grandInwardData: {
          stock_item_id: "110",
          quantity: "15",
          rate: 8400,
          value: 126000,
          total_nos_box: "15"
        },
        grandOutwardData: {
          stock_item_id: "110",
          quantity: "12",
          rate: 11000,
          value: 132000,
          gross_value: 132000,
          total_nos_box: "12",
          consumption_value: 100800,
          gross_profit: 31200,
          profit_per: 23.64
        },
        grandClosingData: {
          stock_item_id: "110",
          quantity: "11",
          rate: "8400.00",
          value: 92400,
          total_nos_box: "11"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Clothing",
      item_name: "Men's Formal Shirt",
      stock_item_id: "111"
    },
    grandOpeningData: {
      stock_item_id: "111",
      quantity: "50",
      rate: 800,
      value: 40000,
      total_nos_box: "50"
    },
    grandInwardData: {
      stock_item_id: "111",
      quantity: "80",
      rate: 780,
      value: 62400,
      total_nos_box: "80"
    },
    grandOutwardData: {
      stock_item_id: "111",
      quantity: "65",
      rate: 1200,
      value: 78000,
      consumption_value: 50700,
      gross_profit: 27300,
      profit_per: 35.00,
      total_nos_box: "65"
    },
    grandClosingData: {
      stock_item_id: "111",
      quantity: "65",
      rate: 780,
      value: 50700,
      total_nos_box: "65"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "111",
          quantity: "50",
          rate: 800,
          value: 40000,
          total_nos_box: "50"
        },
        grandInwardData: {
          stock_item_id: "111",
          quantity: "80",
          rate: 780,
          value: 62400,
          total_nos_box: "80"
        },
        grandOutwardData: {
          stock_item_id: "111",
          quantity: "65",
          rate: 1200,
          value: 78000,
          gross_value: 78000,
          total_nos_box: "65",
          consumption_value: 50700,
          gross_profit: 27300,
          profit_per: 35.00
        },
        grandClosingData: {
          stock_item_id: "111",
          quantity: "65",
          rate: "780.00",
          value: 50700,
          total_nos_box: "65"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Clothing",
      item_name: "Women's Handbag Leather",
      stock_item_id: "112"
    },
    grandOpeningData: {
      stock_item_id: "112",
      quantity: "25",
      rate: 2500,
      value: 62500,
      total_nos_box: "25"
    },
    grandInwardData: {
      stock_item_id: "112",
      quantity: "40",
      rate: 2400,
      value: 96000,
      total_nos_box: "40"
    },
    grandOutwardData: {
      stock_item_id: "112",
      quantity: "30",
      rate: 3200,
      value: 96000,
      consumption_value: 72000,
      gross_profit: 24000,
      profit_per: 25.00,
      total_nos_box: "30"
    },
    grandClosingData: {
      stock_item_id: "112",
      quantity: "35",
      rate: 2400,
      value: 84000,
      total_nos_box: "35"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "112",
          quantity: "25",
          rate: 2500,
          value: 62500,
          total_nos_box: "25"
        },
        grandInwardData: {
          stock_item_id: "112",
          quantity: "40",
          rate: 2400,
          value: 96000,
          total_nos_box: "40"
        },
        grandOutwardData: {
          stock_item_id: "112",
          quantity: "30",
          rate: 3200,
          value: 96000,
          gross_value: 96000,
          total_nos_box: "30",
          consumption_value: 72000,
          gross_profit: 24000,
          profit_per: 25.00
        },
        grandClosingData: {
          stock_item_id: "112",
          quantity: "35",
          rate: "2400.00",
          value: 84000,
          total_nos_box: "35"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Clothing",
      item_name: "Kids Winter Jacket",
      stock_item_id: "113"
    },
    grandOpeningData: {
      stock_item_id: "113",
      quantity: "30",
      rate: 1200,
      value: 36000,
      total_nos_box: "30"
    },
    grandInwardData: {
      stock_item_id: "113",
      quantity: "50",
      rate: 1180,
      value: 59000,
      total_nos_box: "50"
    },
    grandOutwardData: {
      stock_item_id: "113",
      quantity: "40",
      rate: 1600,
      value: 64000,
      consumption_value: 47200,
      gross_profit: 16800,
      profit_per: 26.25,
      total_nos_box: "40"
    },
    grandClosingData: {
      stock_item_id: "113",
      quantity: "40",
      rate: 1180,
      value: 47200,
      total_nos_box: "40"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "113",
          quantity: "30",
          rate: 1200,
          value: 36000,
          total_nos_box: "30"
        },
        grandInwardData: {
          stock_item_id: "113",
          quantity: "50",
          rate: 1180,
          value: 59000,
          total_nos_box: "50"
        },
        grandOutwardData: {
          stock_item_id: "113",
          quantity: "40",
          rate: 1600,
          value: 64000,
          gross_value: 64000,
          total_nos_box: "40",
          consumption_value: 47200,
          gross_profit: 16800,
          profit_per: 26.25
        },
        grandClosingData: {
          stock_item_id: "113",
          quantity: "40",
          rate: "1180.00",
          value: 47200,
          total_nos_box: "40"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Clothing",
      item_name: "Denim Jeans Men",
      stock_item_id: "114"
    },
    grandOpeningData: {
      stock_item_id: "114",
      quantity: "60",
      rate: 900,
      value: 54000,
      total_nos_box: "60"
    },
    grandInwardData: {
      stock_item_id: "114",
      quantity: "100",
      rate: 880,
      value: 88000,
      total_nos_box: "100"
    },
    grandOutwardData: {
      stock_item_id: "114",
      quantity: "80",
      rate: 1300,
      value: 104000,
      consumption_value: 70400,
      gross_profit: 33600,
      profit_per: 32.31,
      total_nos_box: "80"
    },
    grandClosingData: {
      stock_item_id: "114",
      quantity: "80",
      rate: 880,
      value: 70400,
      total_nos_box: "80"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "114",
          quantity: "60",
          rate: 900,
          value: 54000,
          total_nos_box: "60"
        },
        grandInwardData: {
          stock_item_id: "114",
          quantity: "100",
          rate: 880,
          value: 88000,
          total_nos_box: "100"
        },
        grandOutwardData: {
          stock_item_id: "114",
          quantity: "80",
          rate: 1300,
          value: 104000,
          gross_value: 104000,
          total_nos_box: "80",
          consumption_value: 70400,
          gross_profit: 33600,
          profit_per: 32.31
        },
        grandClosingData: {
          stock_item_id: "114",
          quantity: "80",
          rate: "880.00",
          value: 70400,
          total_nos_box: "80"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Clothing",
      item_name: "Summer Dress Women",
      stock_item_id: "115"
    },
    grandOpeningData: {
      stock_item_id: "115",
      quantity: "40",
      rate: 1500,
      value: 60000,
      total_nos_box: "40"
    },
    grandInwardData: {
      stock_item_id: "115",
      quantity: "70",
      rate: 1480,
      value: 103600,
      total_nos_box: "70"
    },
    grandOutwardData: {
      stock_item_id: "115",
      quantity: "55",
      rate: 2000,
      value: 110000,
      consumption_value: 81400,
      gross_profit: 28600,
      profit_per: 26.00,
      total_nos_box: "55"
    },
    grandClosingData: {
      stock_item_id: "115",
      quantity: "55",
      rate: 1480,
      value: 81400,
      total_nos_box: "55"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "115",
          quantity: "40",
          rate: 1500,
          value: 60000,
          total_nos_box: "40"
        },
        grandInwardData: {
          stock_item_id: "115",
          quantity: "70",
          rate: 1480,
          value: 103600,
          total_nos_box: "70"
        },
        grandOutwardData: {
          stock_item_id: "115",
          quantity: "55",
          rate: 2000,
          value: 110000,
          gross_value: 110000,
          total_nos_box: "55",
          consumption_value: 81400,
          gross_profit: 28600,
          profit_per: 26.00
        },
        grandClosingData: {
          stock_item_id: "115",
          quantity: "55",
          rate: "1480.00",
          value: 81400,
          total_nos_box: "55"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Books",
      item_name: "Business Management Guide",
      stock_item_id: "116"
    },
    grandOpeningData: {
      stock_item_id: "116",
      quantity: "100",
      rate: 150,
      value: 15000,
      total_nos_box: "100"
    },
    grandInwardData: {
      stock_item_id: "116",
      quantity: "150",
      rate: 145,
      value: 21750,
      total_nos_box: "150"
    },
    grandOutwardData: {
      stock_item_id: "116",
      quantity: "120",
      rate: 250,
      value: 30000,
      consumption_value: 17400,
      gross_profit: 12600,
      profit_per: 42.00,
      total_nos_box: "120"
    },
    grandClosingData: {
      stock_item_id: "116",
      quantity: "130",
      rate: 145,
      value: 18850,
      total_nos_box: "130"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "116",
          quantity: "100",
          rate: 150,
          value: 15000,
          total_nos_box: "100"
        },
        grandInwardData: {
          stock_item_id: "116",
          quantity: "150",
          rate: 145,
          value: 21750,
          total_nos_box: "150"
        },
        grandOutwardData: {
          stock_item_id: "116",
          quantity: "120",
          rate: 250,
          value: 30000,
          gross_value: 30000,
          total_nos_box: "120",
          consumption_value: 17400,
          gross_profit: 12600,
          profit_per: 42.00
        },
        grandClosingData: {
          stock_item_id: "116",
          quantity: "130",
          rate: "145.00",
          value: 18850,
          total_nos_box: "130"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Books",
      item_name: "Programming Fundamentals",
      stock_item_id: "117"
    },
    grandOpeningData: {
      stock_item_id: "117",
      quantity: "80",
      rate: 200,
      value: 16000,
      total_nos_box: "80"
    },
    grandInwardData: {
      stock_item_id: "117",
      quantity: "120",
      rate: 195,
      value: 23400,
      total_nos_box: "120"
    },
    grandOutwardData: {
      stock_item_id: "117",
      quantity: "95",
      rate: 320,
      value: 30400,
      consumption_value: 18525,
      gross_profit: 11875,
      profit_per: 39.06,
      total_nos_box: "95"
    },
    grandClosingData: {
      stock_item_id: "117",
      quantity: "105",
      rate: 195,
      value: 20475,
      total_nos_box: "105"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "117",
          quantity: "80",
          rate: 200,
          value: 16000,
          total_nos_box: "80"
        },
        grandInwardData: {
          stock_item_id: "117",
          quantity: "120",
          rate: 195,
          value: 23400,
          total_nos_box: "120"
        },
        grandOutwardData: {
          stock_item_id: "117",
          quantity: "95",
          rate: 320,
          value: 30400,
          gross_value: 30400,
          total_nos_box: "95",
          consumption_value: 18525,
          gross_profit: 11875,
          profit_per: 39.06
        },
        grandClosingData: {
          stock_item_id: "117",
          quantity: "105",
          rate: "195.00",
          value: 20475,
          total_nos_box: "105"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Sports",
      item_name: "Yoga Mat Premium",
      stock_item_id: "118"
    },
    grandOpeningData: {
      stock_item_id: "118",
      quantity: "30",
      rate: 800,
      value: 24000,
      total_nos_box: "30"
    },
    grandInwardData: {
      stock_item_id: "118",
      quantity: "45",
      rate: 780,
      value: 35100,
      total_nos_box: "45"
    },
    grandOutwardData: {
      stock_item_id: "118",
      quantity: "35",
      rate: 1100,
      value: 38500,
      consumption_value: 27300,
      gross_profit: 11200,
      profit_per: 29.09,
      total_nos_box: "35"
    },
    grandClosingData: {
      stock_item_id: "118",
      quantity: "40",
      rate: 780,
      value: 31200,
      total_nos_box: "40"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "118",
          quantity: "30",
          rate: 800,
          value: 24000,
          total_nos_box: "30"
        },
        grandInwardData: {
          stock_item_id: "118",
          quantity: "45",
          rate: 780,
          value: 35100,
          total_nos_box: "45"
        },
        grandOutwardData: {
          stock_item_id: "118",
          quantity: "35",
          rate: 1100,
          value: 38500,
          gross_value: 38500,
          total_nos_box: "35",
          consumption_value: 27300,
          gross_profit: 11200,
          profit_per: 29.09
        },
        grandClosingData: {
          stock_item_id: "118",
          quantity: "40",
          rate: "780.00",
          value: 31200,
          total_nos_box: "40"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Sports",
      item_name: "Tennis Racket Pro",
      stock_item_id: "119"
    },
    grandOpeningData: {
      stock_item_id: "119",
      quantity: "25",
      rate: 1800,
      value: 45000,
      total_nos_box: "25"
    },
    grandInwardData: {
      stock_item_id: "119",
      quantity: "40",
      rate: 1750,
      value: 70000,
      total_nos_box: "40"
    },
    grandOutwardData: {
      stock_item_id: "119",
      quantity: "30",
      rate: 2400,
      value: 72000,
      consumption_value: 52500,
      gross_profit: 19500,
      profit_per: 27.08,
      total_nos_box: "30"
    },
    grandClosingData: {
      stock_item_id: "119",
      quantity: "35",
      rate: 1750,
      value: 61250,
      total_nos_box: "35"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "119",
          quantity: "25",
          rate: 1800,
          value: 45000,
          total_nos_box: "25"
        },
        grandInwardData: {
          stock_item_id: "119",
          quantity: "40",
          rate: 1750,
          value: 70000,
          total_nos_box: "40"
        },
        grandOutwardData: {
          stock_item_id: "119",
          quantity: "30",
          rate: 2400,
          value: 72000,
          gross_value: 72000,
          total_nos_box: "30",
          consumption_value: 52500,
          gross_profit: 19500,
          profit_per: 27.08
        },
        grandClosingData: {
          stock_item_id: "119",
          quantity: "35",
          rate: "1750.00",
          value: 61250,
          total_nos_box: "35"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Sports",
      item_name: "Football Size 5",
      stock_item_id: "120"
    },
    grandOpeningData: {
      stock_item_id: "120",
      quantity: "50",
      rate: 400,
      value: 20000,
      total_nos_box: "50"
    },
    grandInwardData: {
      stock_item_id: "120",
      quantity: "80",
      rate: 380,
      value: 30400,
      total_nos_box: "80"
    },
    grandOutwardData: {
      stock_item_id: "120",
      quantity: "65",
      rate: 550,
      value: 35750,
      consumption_value: 24700,
      gross_profit: 11050,
      profit_per: 30.91,
      total_nos_box: "65"
    },
    grandClosingData: {
      stock_item_id: "120",
      quantity: "65",
      rate: 380,
      value: 24700,
      total_nos_box: "65"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "120",
          quantity: "50",
          rate: 400,
          value: 20000,
          total_nos_box: "50"
        },
        grandInwardData: {
          stock_item_id: "120",
          quantity: "80",
          rate: 380,
          value: 30400,
          total_nos_box: "80"
        },
        grandOutwardData: {
          stock_item_id: "120",
          quantity: "65",
          rate: 550,
          value: 35750,
          gross_value: 35750,
          total_nos_box: "65",
          consumption_value: 24700,
          gross_profit: 11050,
          profit_per: 30.91
        },
        grandClosingData: {
          stock_item_id: "120",
          quantity: "65",
          rate: "380.00",
          value: 24700,
          total_nos_box: "65"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Kitchen",
      item_name: "Stainless Steel Cookware Set",
      stock_item_id: "121"
    },
    grandOpeningData: {
      stock_item_id: "121",
      quantity: "15",
      rate: 3500,
      value: 52500,
      total_nos_box: "15"
    },
    grandInwardData: {
      stock_item_id: "121",
      quantity: "25",
      rate: 3400,
      value: 85000,
      total_nos_box: "25"
    },
    grandOutwardData: {
      stock_item_id: "121",
      quantity: "18",
      rate: 4500,
      value: 81000,
      consumption_value: 61200,
      gross_profit: 19800,
      profit_per: 24.44,
      total_nos_box: "18"
    },
    grandClosingData: {
      stock_item_id: "121",
      quantity: "22",
      rate: 3400,
      value: 74800,
      total_nos_box: "22"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "121",
          quantity: "15",
          rate: 3500,
          value: 52500,
          total_nos_box: "15"
        },
        grandInwardData: {
          stock_item_id: "121",
          quantity: "25",
          rate: 3400,
          value: 85000,
          total_nos_box: "25"
        },
        grandOutwardData: {
          stock_item_id: "121",
          quantity: "18",
          rate: 4500,
          value: 81000,
          gross_value: 81000,
          total_nos_box: "18",
          consumption_value: 61200,
          gross_profit: 19800,
          profit_per: 24.44
        },
        grandClosingData: {
          stock_item_id: "121",
          quantity: "22",
          rate: "3400.00",
          value: 74800,
          total_nos_box: "22"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Kitchen",
      item_name: "Electric Rice Cooker",
      stock_item_id: "122"
    },
    grandOpeningData: {
      stock_item_id: "122",
      quantity: "20",
      rate: 1200,
      value: 24000,
      total_nos_box: "20"
    },
    grandInwardData: {
      stock_item_id: "122",
      quantity: "35",
      rate: 1180,
      value: 41300,
      total_nos_box: "35"
    },
    grandOutwardData: {
      stock_item_id: "122",
      quantity: "28",
      rate: 1600,
      value: 44800,
      consumption_value: 33040,
      gross_profit: 11760,
      profit_per: 26.25,
      total_nos_box: "28"
    },
    grandClosingData: {
      stock_item_id: "122",
      quantity: "27",
      rate: 1180,
      value: 31860,
      total_nos_box: "27"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "122",
          quantity: "20",
          rate: 1200,
          value: 24000,
          total_nos_box: "20"
        },
        grandInwardData: {
          stock_item_id: "122",
          quantity: "35",
          rate: 1180,
          value: 41300,
          total_nos_box: "35"
        },
        grandOutwardData: {
          stock_item_id: "122",
          quantity: "28",
          rate: 1600,
          value: 44800,
          gross_value: 44800,
          total_nos_box: "28",
          consumption_value: 33040,
          gross_profit: 11760,
          profit_per: 26.25
        },
        grandClosingData: {
          stock_item_id: "122",
          quantity: "27",
          rate: "1180.00",
          value: 31860,
          total_nos_box: "27"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Kitchen",
      item_name: "Coffee Maker Deluxe",
      stock_item_id: "123"
    },
    grandOpeningData: {
      stock_item_id: "123",
      quantity: "12",
      rate: 2800,
      value: 33600,
      total_nos_box: "12"
    },
    grandInwardData: {
      stock_item_id: "123",
      quantity: "20",
      rate: 2750,
      value: 55000,
      total_nos_box: "20"
    },
    grandOutwardData: {
      stock_item_id: "123",
      quantity: "16",
      rate: 3800,
      value: 60800,
      consumption_value: 44000,
      gross_profit: 16800,
      profit_per: 27.63,
      total_nos_box: "16"
    },
    grandClosingData: {
      stock_item_id: "123",
      quantity: "16",
      rate: 2750,
      value: 44000,
      total_nos_box: "16"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "123",
          quantity: "12",
          rate: 2800,
          value: 33600,
          total_nos_box: "12"
        },
        grandInwardData: {
          stock_item_id: "123",
          quantity: "20",
          rate: 2750,
          value: 55000,
          total_nos_box: "20"
        },
        grandOutwardData: {
          stock_item_id: "123",
          quantity: "16",
          rate: 3800,
          value: 60800,
          gross_value: 60800,
          total_nos_box: "16",
          consumption_value: 44000,
          gross_profit: 16800,
          profit_per: 27.63
        },
        grandClosingData: {
          stock_item_id: "123",
          quantity: "16",
          rate: "2750.00",
          value: 44000,
          total_nos_box: "16"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Automotive",
      item_name: "Car Air Freshener Pack",
      stock_item_id: "124"
    },
    grandOpeningData: {
      stock_item_id: "124",
      quantity: "200",
      rate: 50,
      value: 10000,
      total_nos_box: "200"
    },
    grandInwardData: {
      stock_item_id: "124",
      quantity: "300",
      rate: 48,
      value: 14400,
      total_nos_box: "300"
    },
    grandOutwardData: {
      stock_item_id: "124",
      quantity: "250",
      rate: 80,
      value: 20000,
      consumption_value: 12000,
      gross_profit: 8000,
      profit_per: 40.00,
      total_nos_box: "250"
    },
    grandClosingData: {
      stock_item_id: "124",
      quantity: "250",
      rate: 48,
      value: 12000,
      total_nos_box: "250"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "124",
          quantity: "200",
          rate: 50,
          value: 10000,
          total_nos_box: "200"
        },
        grandInwardData: {
          stock_item_id: "124",
          quantity: "300",
          rate: 48,
          value: 14400,
          total_nos_box: "300"
        },
        grandOutwardData: {
          stock_item_id: "124",
          quantity: "250",
          rate: 80,
          value: 20000,
          gross_value: 20000,
          total_nos_box: "250",
          consumption_value: 12000,
          gross_profit: 8000,
          profit_per: 40.00
        },
        grandClosingData: {
          stock_item_id: "124",
          quantity: "250",
          rate: "48.00",
          value: 12000,
          total_nos_box: "250"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Automotive",
      item_name: "Car Floor Mats Set",
      stock_item_id: "125"
    },
    grandOpeningData: {
      stock_item_id: "125",
      quantity: "30",
      rate: 800,
      value: 24000,
      total_nos_box: "30"
    },
    grandInwardData: {
      stock_item_id: "125",
      quantity: "50",
      rate: 780,
      value: 39000,
      total_nos_box: "50"
    },
    grandOutwardData: {
      stock_item_id: "125",
      quantity: "40",
      rate: 1100,
      value: 44000,
      consumption_value: 31200,
      gross_profit: 12800,
      profit_per: 29.09,
      total_nos_box: "40"
    },
    grandClosingData: {
      stock_item_id: "125",
      quantity: "40",
      rate: 780,
      value: 31200,
      total_nos_box: "40"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "125",
          quantity: "30",
          rate: 800,
          value: 24000,
          total_nos_box: "30"
        },
        grandInwardData: {
          stock_item_id: "125",
          quantity: "50",
          rate: 780,
          value: 39000,
          total_nos_box: "50"
        },
        grandOutwardData: {
          stock_item_id: "125",
          quantity: "40",
          rate: 1100,
          value: 44000,
          gross_value: 44000,
          total_nos_box: "40",
          consumption_value: 31200,
          gross_profit: 12800,
          profit_per: 29.09
        },
        grandClosingData: {
          stock_item_id: "125",
          quantity: "40",
          rate: "780.00",
          value: 31200,
          total_nos_box: "40"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Home & Garden",
      item_name: "LED Garden Lights Set",
      stock_item_id: "126"
    },
    grandOpeningData: {
      stock_item_id: "126",
      quantity: "40",
      rate: 1200,
      value: 48000,
      total_nos_box: "40"
    },
    grandInwardData: {
      stock_item_id: "126",
      quantity: "60",
      rate: 1150,
      value: 69000,
      total_nos_box: "60"
    },
    grandOutwardData: {
      stock_item_id: "126",
      quantity: "45",
      rate: 1800,
      value: 81000,
      consumption_value: 51750,
      gross_profit: 29250,
      profit_per: 36.11,
      total_nos_box: "45"
    },
    grandClosingData: {
      stock_item_id: "126",
      quantity: "55",
      rate: 1150,
      value: 63250,
      total_nos_box: "55"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "126",
          quantity: "40",
          rate: 1200,
          value: 48000,
          total_nos_box: "40"
        },
        grandInwardData: {
          stock_item_id: "126",
          quantity: "60",
          rate: 1150,
          value: 69000,
          total_nos_box: "60"
        },
        grandOutwardData: {
          stock_item_id: "126",
          quantity: "45",
          rate: 1800,
          value: 81000,
          gross_value: 81000,
          total_nos_box: "45",
          consumption_value: 51750,
          gross_profit: 29250,
          profit_per: 36.11
        },
        grandClosingData: {
          stock_item_id: "126",
          quantity: "55",
          rate: "1150.00",
          value: 63250,
          total_nos_box: "55"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Home & Garden",
      item_name: "Garden Hose 50m",
      stock_item_id: "127"
    },
    grandOpeningData: {
      stock_item_id: "127",
      quantity: "25",
      rate: 800,
      value: 20000,
      total_nos_box: "25"
    },
    grandInwardData: {
      stock_item_id: "127",
      quantity: "40",
      rate: 780,
      value: 31200,
      total_nos_box: "40"
    },
    grandOutwardData: {
      stock_item_id: "127",
      quantity: "30",
      rate: 1100,
      value: 33000,
      consumption_value: 23400,
      gross_profit: 9600,
      profit_per: 29.09,
      total_nos_box: "30"
    },
    grandClosingData: {
      stock_item_id: "127",
      quantity: "35",
      rate: 780,
      value: 27300,
      total_nos_box: "35"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "127",
          quantity: "25",
          rate: 800,
          value: 20000,
          total_nos_box: "25"
        },
        grandInwardData: {
          stock_item_id: "127",
          quantity: "40",
          rate: 780,
          value: 31200,
          total_nos_box: "40"
        },
        grandOutwardData: {
          stock_item_id: "127",
          quantity: "30",
          rate: 1100,
          value: 33000,
          gross_value: 33000,
          total_nos_box: "30",
          consumption_value: 23400,
          gross_profit: 9600,
          profit_per: 29.09
        },
        grandClosingData: {
          stock_item_id: "127",
          quantity: "35",
          rate: "780.00",
          value: 27300,
          total_nos_box: "35"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Beauty & Health",
      item_name: "Organic Face Cream",
      stock_item_id: "128"
    },
    grandOpeningData: {
      stock_item_id: "128",
      quantity: "80",
      rate: 450,
      value: 36000,
      total_nos_box: "80"
    },
    grandInwardData: {
      stock_item_id: "128",
      quantity: "120",
      rate: 430,
      value: 51600,
      total_nos_box: "120"
    },
    grandOutwardData: {
      stock_item_id: "128",
      quantity: "95",
      rate: 650,
      value: 61750,
      consumption_value: 40850,
      gross_profit: 20900,
      profit_per: 33.85,
      total_nos_box: "95"
    },
    grandClosingData: {
      stock_item_id: "128",
      quantity: "105",
      rate: 430,
      value: 45150,
      total_nos_box: "105"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "128",
          quantity: "80",
          rate: 450,
          value: 36000,
          total_nos_box: "80"
        },
        grandInwardData: {
          stock_item_id: "128",
          quantity: "120",
          rate: 430,
          value: 51600,
          total_nos_box: "120"
        },
        grandOutwardData: {
          stock_item_id: "128",
          quantity: "95",
          rate: 650,
          value: 61750,
          gross_value: 61750,
          total_nos_box: "95",
          consumption_value: 40850,
          gross_profit: 20900,
          profit_per: 33.85
        },
        grandClosingData: {
          stock_item_id: "128",
          quantity: "105",
          rate: "430.00",
          value: 45150,
          total_nos_box: "105"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Beauty & Health",
      item_name: "Hair Dryer Professional",
      stock_item_id: "129"
    },
    grandOpeningData: {
      stock_item_id: "129",
      quantity: "35",
      rate: 1200,
      value: 42000,
      total_nos_box: "35"
    },
    grandInwardData: {
      stock_item_id: "129",
      quantity: "55",
      rate: 1180,
      value: 64900,
      total_nos_box: "55"
    },
    grandOutwardData: {
      stock_item_id: "129",
      quantity: "45",
      rate: 1600,
      value: 72000,
      consumption_value: 53100,
      gross_profit: 18900,
      profit_per: 26.25,
      total_nos_box: "45"
    },
    grandClosingData: {
      stock_item_id: "129",
      quantity: "45",
      rate: 1180,
      value: 53100,
      total_nos_box: "45"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "129",
          quantity: "35",
          rate: 1200,
          value: 42000,
          total_nos_box: "35"
        },
        grandInwardData: {
          stock_item_id: "129",
          quantity: "55",
          rate: 1180,
          value: 64900,
          total_nos_box: "55"
        },
        grandOutwardData: {
          stock_item_id: "129",
          quantity: "45",
          rate: 1600,
          value: 72000,
          gross_value: 72000,
          total_nos_box: "45",
          consumption_value: 53100,
          gross_profit: 18900,
          profit_per: 26.25
        },
        grandClosingData: {
          stock_item_id: "129",
          quantity: "45",
          rate: "1180.00",
          value: 53100,
          total_nos_box: "45"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Toys & Games",
      item_name: "Educational Building Blocks",
      stock_item_id: "130"
    },
    grandOpeningData: {
      stock_item_id: "130",
      quantity: "150",
      rate: 180,
      value: 27000,
      total_nos_box: "150"
    },
    grandInwardData: {
      stock_item_id: "130",
      quantity: "200",
      rate: 175,
      value: 35000,
      total_nos_box: "200"
    },
    grandOutwardData: {
      stock_item_id: "130",
      quantity: "180",
      rate: 280,
      value: 50400,
      consumption_value: 31500,
      gross_profit: 18900,
      profit_per: 37.50,
      total_nos_box: "180"
    },
    grandClosingData: {
      stock_item_id: "130",
      quantity: "170",
      rate: 175,
      value: 29750,
      total_nos_box: "170"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "130",
          quantity: "150",
          rate: 180,
          value: 27000,
          total_nos_box: "150"
        },
        grandInwardData: {
          stock_item_id: "130",
          quantity: "200",
          rate: 175,
          value: 35000,
          total_nos_box: "200"
        },
        grandOutwardData: {
          stock_item_id: "130",
          quantity: "180",
          rate: 280,
          value: 50400,
          gross_value: 50400,
          total_nos_box: "180",
          consumption_value: 31500,
          gross_profit: 18900,
          profit_per: 37.50
        },
        grandClosingData: {
          stock_item_id: "130",
          quantity: "170",
          rate: "175.00",
          value: 29750,
          total_nos_box: "170"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Office Supplies",
      item_name: "Premium Notebook Set",
      stock_item_id: "131"
    },
    grandOpeningData: {
      stock_item_id: "131",
      quantity: "200",
      rate: 120,
      value: 24000,
      total_nos_box: "200"
    },
    grandInwardData: {
      stock_item_id: "131",
      quantity: "300",
      rate: 115,
      value: 34500,
      total_nos_box: "300"
    },
    grandOutwardData: {
      stock_item_id: "131",
      quantity: "250",
      rate: 180,
      value: 45000,
      consumption_value: 28750,
      gross_profit: 16250,
      profit_per: 36.11,
      total_nos_box: "250"
    },
    grandClosingData: {
      stock_item_id: "131",
      quantity: "250",
      rate: 115,
      value: 28750,
      total_nos_box: "250"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "131",
          quantity: "200",
          rate: 120,
          value: 24000,
          total_nos_box: "200"
        },
        grandInwardData: {
          stock_item_id: "131",
          quantity: "300",
          rate: 115,
          value: 34500,
          total_nos_box: "300"
        },
        grandOutwardData: {
          stock_item_id: "131",
          quantity: "250",
          rate: 180,
          value: 45000,
          gross_value: 45000,
          total_nos_box: "250",
          consumption_value: 28750,
          gross_profit: 16250,
          profit_per: 36.11
        },
        grandClosingData: {
          stock_item_id: "131",
          quantity: "250",
          rate: "115.00",
          value: 28750,
          total_nos_box: "250"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Office Supplies",
      item_name: "Desk Organizer Set",
      stock_item_id: "132"
    },
    grandOpeningData: {
      stock_item_id: "132",
      quantity: "45",
      rate: 600,
      value: 27000,
      total_nos_box: "45"
    },
    grandInwardData: {
      stock_item_id: "132",
      quantity: "70",
      rate: 580,
      value: 40600,
      total_nos_box: "70"
    },
    grandOutwardData: {
      stock_item_id: "132",
      quantity: "55",
      rate: 800,
      value: 44000,
      consumption_value: 31900,
      gross_profit: 12100,
      profit_per: 27.50,
      total_nos_box: "55"
    },
    grandClosingData: {
      stock_item_id: "132",
      quantity: "60",
      rate: 580,
      value: 34800,
      total_nos_box: "60"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "132",
          quantity: "45",
          rate: 600,
          value: 27000,
          total_nos_box: "45"
        },
        grandInwardData: {
          stock_item_id: "132",
          quantity: "70",
          rate: 580,
          value: 40600,
          total_nos_box: "70"
        },
        grandOutwardData: {
          stock_item_id: "132",
          quantity: "55",
          rate: 800,
          value: 44000,
          gross_value: 44000,
          total_nos_box: "55",
          consumption_value: 31900,
          gross_profit: 12100,
          profit_per: 27.50
        },
        grandClosingData: {
          stock_item_id: "132",
          quantity: "60",
          rate: "580.00",
          value: 34800,
          total_nos_box: "60"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Pet Supplies",
      item_name: "Premium Dog Food 20kg",
      stock_item_id: "133"
    },
    grandOpeningData: {
      stock_item_id: "133",
      quantity: "25",
      rate: 1800,
      value: 45000,
      total_nos_box: "25"
    },
    grandInwardData: {
      stock_item_id: "133",
      quantity: "40",
      rate: 1750,
      value: 70000,
      total_nos_box: "40"
    },
    grandOutwardData: {
      stock_item_id: "133",
      quantity: "30",
      rate: 2400,
      value: 72000,
      consumption_value: 52500,
      gross_profit: 19500,
      profit_per: 27.08,
      total_nos_box: "30"
    },
    grandClosingData: {
      stock_item_id: "133",
      quantity: "35",
      rate: 1750,
      value: 61250,
      total_nos_box: "35"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "133",
          quantity: "25",
          rate: 1800,
          value: 45000,
          total_nos_box: "25"
        },
        grandInwardData: {
          stock_item_id: "133",
          quantity: "40",
          rate: 1750,
          value: 70000,
          total_nos_box: "40"
        },
        grandOutwardData: {
          stock_item_id: "133",
          quantity: "30",
          rate: 2400,
          value: 72000,
          gross_value: 72000,
          total_nos_box: "30",
          consumption_value: 52500,
          gross_profit: 19500,
          profit_per: 27.08
        },
        grandClosingData: {
          stock_item_id: "133",
          quantity: "35",
          rate: "1750.00",
          value: 61250,
          total_nos_box: "35"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Pet Supplies",
      item_name: "Cat Scratching Post",
      stock_item_id: "134"
    },
    grandOpeningData: {
      stock_item_id: "134",
      quantity: "30",
      rate: 800,
      value: 24000,
      total_nos_box: "30"
    },
    grandInwardData: {
      stock_item_id: "134",
      quantity: "50",
      rate: 780,
      value: 39000,
      total_nos_box: "50"
    },
    grandOutwardData: {
      stock_item_id: "134",
      quantity: "40",
      rate: 1100,
      value: 44000,
      consumption_value: 31200,
      gross_profit: 12800,
      profit_per: 29.09,
      total_nos_box: "40"
    },
    grandClosingData: {
      stock_item_id: "134",
      quantity: "40",
      rate: 780,
      value: 31200,
      total_nos_box: "40"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "134",
          quantity: "30",
          rate: 800,
          value: 24000,
          total_nos_box: "30"
        },
        grandInwardData: {
          stock_item_id: "134",
          quantity: "50",
          rate: 780,
          value: 39000,
          total_nos_box: "50"
        },
        grandOutwardData: {
          stock_item_id: "134",
          quantity: "40",
          rate: 1100,
          value: 44000,
          gross_value: 44000,
          total_nos_box: "40",
          consumption_value: 31200,
          gross_profit: 12800,
          profit_per: 29.09
        },
        grandClosingData: {
          stock_item_id: "134",
          quantity: "40",
          rate: "780.00",
          value: 31200,
          total_nos_box: "40"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Pet Supplies",
      item_name: "Bird Cage Large",
      stock_item_id: "135"
    },
    grandOpeningData: {
      stock_item_id: "135",
      quantity: "20",
      rate: 1200,
      value: 24000,
      total_nos_box: "20"
    },
    grandInwardData: {
      stock_item_id: "135",
      quantity: "35",
      rate: 1180,
      value: 41300,
      total_nos_box: "35"
    },
    grandOutwardData: {
      stock_item_id: "135",
      quantity: "28",
      rate: 1600,
      value: 44800,
      consumption_value: 33040,
      gross_profit: 11760,
      profit_per: 26.25,
      total_nos_box: "28"
    },
    grandClosingData: {
      stock_item_id: "135",
      quantity: "27",
      rate: 1180,
      value: 31860,
      total_nos_box: "27"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "135",
          quantity: "20",
          rate: 1200,
          value: 24000,
          total_nos_box: "20"
        },
        grandInwardData: {
          stock_item_id: "135",
          quantity: "35",
          rate: 1180,
          value: 41300,
          total_nos_box: "35"
        },
        grandOutwardData: {
          stock_item_id: "135",
          quantity: "28",
          rate: 1600,
          value: 44800,
          gross_value: 44800,
          total_nos_box: "28",
          consumption_value: 33040,
          gross_profit: 11760,
          profit_per: 26.25
        },
        grandClosingData: {
          stock_item_id: "135",
          quantity: "27",
          rate: "1180.00",
          value: 31860,
          total_nos_box: "27"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Jewelry",
      item_name: "Gold Necklace 18K",
      stock_item_id: "136"
    },
    grandOpeningData: {
      stock_item_id: "136",
      quantity: "8",
      rate: 25000,
      value: 200000,
      total_nos_box: "8"
    },
    grandInwardData: {
      stock_item_id: "136",
      quantity: "15",
      rate: 24800,
      value: 372000,
      total_nos_box: "15"
    },
    grandOutwardData: {
      stock_item_id: "136",
      quantity: "12",
      rate: 32000,
      value: 384000,
      consumption_value: 297600,
      gross_profit: 86400,
      profit_per: 22.50,
      total_nos_box: "12"
    },
    grandClosingData: {
      stock_item_id: "136",
      quantity: "11",
      rate: 24800,
      value: 272800,
      total_nos_box: "11"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "136",
          quantity: "8",
          rate: 25000,
          value: 200000,
          total_nos_box: "8"
        },
        grandInwardData: {
          stock_item_id: "136",
          quantity: "15",
          rate: 24800,
          value: 372000,
          total_nos_box: "15"
        },
        grandOutwardData: {
          stock_item_id: "136",
          quantity: "12",
          rate: 32000,
          value: 384000,
          gross_value: 384000,
          total_nos_box: "12",
          consumption_value: 297600,
          gross_profit: 86400,
          profit_per: 22.50
        },
        grandClosingData: {
          stock_item_id: "136",
          quantity: "11",
          rate: "24800.00",
          value: 272800,
          total_nos_box: "11"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Jewelry",
      item_name: "Silver Ring Set",
      stock_item_id: "137"
    },
    grandOpeningData: {
      stock_item_id: "137",
      quantity: "25",
      rate: 1200,
      value: 30000,
      total_nos_box: "25"
    },
    grandInwardData: {
      stock_item_id: "137",
      quantity: "40",
      rate: 1180,
      value: 47200,
      total_nos_box: "40"
    },
    grandOutwardData: {
      stock_item_id: "137",
      quantity: "32",
      rate: 1600,
      value: 51200,
      consumption_value: 37760,
      gross_profit: 13440,
      profit_per: 26.25,
      total_nos_box: "32"
    },
    grandClosingData: {
      stock_item_id: "137",
      quantity: "33",
      rate: 1180,
      value: 38940,
      total_nos_box: "33"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "137",
          quantity: "25",
          rate: 1200,
          value: 30000,
          total_nos_box: "25"
        },
        grandInwardData: {
          stock_item_id: "137",
          quantity: "40",
          rate: 1180,
          value: 47200,
          total_nos_box: "40"
        },
        grandOutwardData: {
          stock_item_id: "137",
          quantity: "32",
          rate: 1600,
          value: 51200,
          gross_value: 51200,
          total_nos_box: "32",
          consumption_value: 37760,
          gross_profit: 13440,
          profit_per: 26.25
        },
        grandClosingData: {
          stock_item_id: "137",
          quantity: "33",
          rate: "1180.00",
          value: 38940,
          total_nos_box: "33"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Music",
      item_name: "Acoustic Guitar",
      stock_item_id: "138"
    },
    grandOpeningData: {
      stock_item_id: "138",
      quantity: "12",
      rate: 3500,
      value: 42000,
      total_nos_box: "12"
    },
    grandInwardData: {
      stock_item_id: "138",
      quantity: "20",
      rate: 3450,
      value: 69000,
      total_nos_box: "20"
    },
    grandOutwardData: {
      stock_item_id: "138",
      quantity: "16",
      rate: 4800,
      value: 76800,
      consumption_value: 55200,
      gross_profit: 21600,
      profit_per: 28.13,
      total_nos_box: "16"
    },
    grandClosingData: {
      stock_item_id: "138",
      quantity: "16",
      rate: 3450,
      value: 55200,
      total_nos_box: "16"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "138",
          quantity: "12",
          rate: 3500,
          value: 42000,
          total_nos_box: "12"
        },
        grandInwardData: {
          stock_item_id: "138",
          quantity: "20",
          rate: 3450,
          value: 69000,
          total_nos_box: "20"
        },
        grandOutwardData: {
          stock_item_id: "138",
          quantity: "16",
          rate: 4800,
          value: 76800,
          gross_value: 76800,
          total_nos_box: "16",
          consumption_value: 55200,
          gross_profit: 21600,
          profit_per: 28.13
        },
        grandClosingData: {
          stock_item_id: "138",
          quantity: "16",
          rate: "3450.00",
          value: 55200,
          total_nos_box: "16"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Music",
      item_name: "Digital Piano 88 Keys",
      stock_item_id: "139"
    },
    grandOpeningData: {
      stock_item_id: "139",
      quantity: "6",
      rate: 15000,
      value: 90000,
      total_nos_box: "6"
    },
    grandInwardData: {
      stock_item_id: "139",
      quantity: "10",
      rate: 14800,
      value: 148000,
      total_nos_box: "10"
    },
    grandOutwardData: {
      stock_item_id: "139",
      quantity: "8",
      rate: 20000,
      value: 160000,
      consumption_value: 118400,
      gross_profit: 41600,
      profit_per: 26.00,
      total_nos_box: "8"
    },
    grandClosingData: {
      stock_item_id: "139",
      quantity: "8",
      rate: 14800,
      value: 118400,
      total_nos_box: "8"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "139",
          quantity: "6",
          rate: 15000,
          value: 90000,
          total_nos_box: "6"
        },
        grandInwardData: {
          stock_item_id: "139",
          quantity: "10",
          rate: 14800,
          value: 148000,
          total_nos_box: "10"
        },
        grandOutwardData: {
          stock_item_id: "139",
          quantity: "8",
          rate: 20000,
          value: 160000,
          gross_value: 160000,
          total_nos_box: "8",
          consumption_value: 118400,
          gross_profit: 41600,
          profit_per: 26.00
        },
        grandClosingData: {
          stock_item_id: "139",
          quantity: "8",
          rate: "14800.00",
          value: 118400,
          total_nos_box: "8"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Music",
      item_name: "Violin Student Grade",
      stock_item_id: "140"
    },
    grandOpeningData: {
      stock_item_id: "140",
      quantity: "15",
      rate: 2800,
      value: 42000,
      total_nos_box: "15"
    },
    grandInwardData: {
      stock_item_id: "140",
      quantity: "25",
      rate: 2750,
      value: 68750,
      total_nos_box: "25"
    },
    grandOutwardData: {
      stock_item_id: "140",
      quantity: "20",
      rate: 3800,
      value: 76000,
      consumption_value: 55000,
      gross_profit: 21000,
      profit_per: 27.63,
      total_nos_box: "20"
    },
    grandClosingData: {
      stock_item_id: "140",
      quantity: "20",
      rate: 2750,
      value: 55000,
      total_nos_box: "20"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "140",
          quantity: "15",
          rate: 2800,
          value: 42000,
          total_nos_box: "15"
        },
        grandInwardData: {
          stock_item_id: "140",
          quantity: "25",
          rate: 2750,
          value: 68750,
          total_nos_box: "25"
        },
        grandOutwardData: {
          stock_item_id: "140",
          quantity: "20",
          rate: 3800,
          value: 76000,
          gross_value: 76000,
          total_nos_box: "20",
          consumption_value: 55000,
          gross_profit: 21000,
          profit_per: 27.63
        },
        grandClosingData: {
          stock_item_id: "140",
          quantity: "20",
          rate: "2750.00",
          value: 55000,
          total_nos_box: "20"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Art & Craft",
      item_name: "Professional Paint Set",
      stock_item_id: "141"
    },
    grandOpeningData: {
      stock_item_id: "141",
      quantity: "30",
      rate: 800,
      value: 24000,
      total_nos_box: "30"
    },
    grandInwardData: {
      stock_item_id: "141",
      quantity: "50",
      rate: 780,
      value: 39000,
      total_nos_box: "50"
    },
    grandOutwardData: {
      stock_item_id: "141",
      quantity: "40",
      rate: 1100,
      value: 44000,
      consumption_value: 31200,
      gross_profit: 12800,
      profit_per: 29.09,
      total_nos_box: "40"
    },
    grandClosingData: {
      stock_item_id: "141",
      quantity: "40",
      rate: 780,
      value: 31200,
      total_nos_box: "40"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "141",
          quantity: "30",
          rate: 800,
          value: 24000,
          total_nos_box: "30"
        },
        grandInwardData: {
          stock_item_id: "141",
          quantity: "50",
          rate: 780,
          value: 39000,
          total_nos_box: "50"
        },
        grandOutwardData: {
          stock_item_id: "141",
          quantity: "40",
          rate: 1100,
          value: 44000,
          gross_value: 44000,
          total_nos_box: "40",
          consumption_value: 31200,
          gross_profit: 12800,
          profit_per: 29.09
        },
        grandClosingData: {
          stock_item_id: "141",
          quantity: "40",
          rate: "780.00",
          value: 31200,
          total_nos_box: "40"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Art & Craft",
      item_name: "Canvas Roll 10m",
      stock_item_id: "142"
    },
    grandOpeningData: {
      stock_item_id: "142",
      quantity: "20",
      rate: 600,
      value: 12000,
      total_nos_box: "20"
    },
    grandInwardData: {
      stock_item_id: "142",
      quantity: "35",
      rate: 580,
      value: 20300,
      total_nos_box: "35"
    },
    grandOutwardData: {
      stock_item_id: "142",
      quantity: "28",
      rate: 800,
      value: 22400,
      consumption_value: 16240,
      gross_profit: 6160,
      profit_per: 27.50,
      total_nos_box: "28"
    },
    grandClosingData: {
      stock_item_id: "142",
      quantity: "27",
      rate: 580,
      value: 15660,
      total_nos_box: "27"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "142",
          quantity: "20",
          rate: 600,
          value: 12000,
          total_nos_box: "20"
        },
        grandInwardData: {
          stock_item_id: "142",
          quantity: "35",
          rate: 580,
          value: 20300,
          total_nos_box: "35"
        },
        grandOutwardData: {
          stock_item_id: "142",
          quantity: "28",
          rate: 800,
          value: 22400,
          gross_value: 22400,
          total_nos_box: "28",
          consumption_value: 16240,
          gross_profit: 6160,
          profit_per: 27.50
        },
        grandClosingData: {
          stock_item_id: "142",
          quantity: "27",
          rate: "580.00",
          value: 15660,
          total_nos_box: "27"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Art & Craft",
      item_name: "Sculpting Clay Set",
      stock_item_id: "143"
    },
    grandOpeningData: {
      stock_item_id: "143",
      quantity: "40",
      rate: 400,
      value: 16000,
      total_nos_box: "40"
    },
    grandInwardData: {
      stock_item_id: "143",
      quantity: "60",
      rate: 380,
      value: 22800,
      total_nos_box: "60"
    },
    grandOutwardData: {
      stock_item_id: "143",
      quantity: "50",
      rate: 550,
      value: 27500,
      consumption_value: 19000,
      gross_profit: 8500,
      profit_per: 30.91,
      total_nos_box: "50"
    },
    grandClosingData: {
      stock_item_id: "143",
      quantity: "50",
      rate: 380,
      value: 19000,
      total_nos_box: "50"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "143",
          quantity: "40",
          rate: 400,
          value: 16000,
          total_nos_box: "40"
        },
        grandInwardData: {
          stock_item_id: "143",
          quantity: "60",
          rate: 380,
          value: 22800,
          total_nos_box: "60"
        },
        grandOutwardData: {
          stock_item_id: "143",
          quantity: "50",
          rate: 550,
          value: 27500,
          gross_value: 27500,
          total_nos_box: "50",
          consumption_value: 19000,
          gross_profit: 8500,
          profit_per: 30.91
        },
        grandClosingData: {
          stock_item_id: "143",
          quantity: "50",
          rate: "380.00",
          value: 19000,
          total_nos_box: "50"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Tools",
      item_name: "Power Drill Set",
      stock_item_id: "144"
    },
    grandOpeningData: {
      stock_item_id: "144",
      quantity: "18",
      rate: 2800,
      value: 50400,
      total_nos_box: "18"
    },
    grandInwardData: {
      stock_item_id: "144",
      quantity: "30",
      rate: 2750,
      value: 82500,
      total_nos_box: "30"
    },
    grandOutwardData: {
      stock_item_id: "144",
      quantity: "24",
      rate: 3800,
      value: 91200,
      consumption_value: 66000,
      gross_profit: 25200,
      profit_per: 27.63,
      total_nos_box: "24"
    },
    grandClosingData: {
      stock_item_id: "144",
      quantity: "24",
      rate: 2750,
      value: 66000,
      total_nos_box: "24"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "144",
          quantity: "18",
          rate: 2800,
          value: 50400,
          total_nos_box: "18"
        },
        grandInwardData: {
          stock_item_id: "144",
          quantity: "30",
          rate: 2750,
          value: 82500,
          total_nos_box: "30"
        },
        grandOutwardData: {
          stock_item_id: "144",
          quantity: "24",
          rate: 3800,
          value: 91200,
          gross_value: 91200,
          total_nos_box: "24",
          consumption_value: 66000,
          gross_profit: 25200,
          profit_per: 27.63
        },
        grandClosingData: {
          stock_item_id: "144",
          quantity: "24",
          rate: "2750.00",
          value: 66000,
          total_nos_box: "24"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Tools",
      item_name: "Measuring Tape Set",
      stock_item_id: "145"
    },
    grandOpeningData: {
      stock_item_id: "145",
      quantity: "60",
      rate: 300,
      value: 18000,
      total_nos_box: "60"
    },
    grandInwardData: {
      stock_item_id: "145",
      quantity: "100",
      rate: 290,
      value: 29000,
      total_nos_box: "100"
    },
    grandOutwardData: {
      stock_item_id: "145",
      quantity: "80",
      rate: 420,
      value: 33600,
      consumption_value: 23200,
      gross_profit: 10400,
      profit_per: 30.95,
      total_nos_box: "80"
    },
    grandClosingData: {
      stock_item_id: "145",
      quantity: "80",
      rate: 290,
      value: 23200,
      total_nos_box: "80"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "145",
          quantity: "60",
          rate: 300,
          value: 18000,
          total_nos_box: "60"
        },
        grandInwardData: {
          stock_item_id: "145",
          quantity: "100",
          rate: 290,
          value: 29000,
          total_nos_box: "100"
        },
        grandOutwardData: {
          stock_item_id: "145",
          quantity: "80",
          rate: 420,
          value: 33600,
          gross_value: 33600,
          total_nos_box: "80",
          consumption_value: 23200,
          gross_profit: 10400,
          profit_per: 30.95
        },
        grandClosingData: {
          stock_item_id: "145",
          quantity: "80",
          rate: "290.00",
          value: 23200,
          total_nos_box: "80"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Tools",
      item_name: "Screwdriver Set",
      stock_item_id: "146"
    },
    grandOpeningData: {
      stock_item_id: "146",
      quantity: "50",
      rate: 200,
      value: 10000,
      total_nos_box: "50"
    },
    grandInwardData: {
      stock_item_id: "146",
      quantity: "80",
      rate: 195,
      value: 15600,
      total_nos_box: "80"
    },
    grandOutwardData: {
      stock_item_id: "146",
      quantity: "65",
      rate: 280,
      value: 18200,
      consumption_value: 12675,
      gross_profit: 5525,
      profit_per: 30.36,
      total_nos_box: "65"
    },
    grandClosingData: {
      stock_item_id: "146",
      quantity: "65",
      rate: 195,
      value: 12675,
      total_nos_box: "65"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "146",
          quantity: "50",
          rate: 200,
          value: 10000,
          total_nos_box: "50"
        },
        grandInwardData: {
          stock_item_id: "146",
          quantity: "80",
          rate: 195,
          value: 15600,
          total_nos_box: "80"
        },
        grandOutwardData: {
          stock_item_id: "146",
          quantity: "65",
          rate: 280,
          value: 18200,
          gross_value: 18200,
          total_nos_box: "65",
          consumption_value: 12675,
          gross_profit: 5525,
          profit_per: 30.36
        },
        grandClosingData: {
          stock_item_id: "146",
          quantity: "65",
          rate: "195.00",
          value: 12675,
          total_nos_box: "65"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Tools",
      item_name: "Hammer Set",
      stock_item_id: "147"
    },
    grandOpeningData: {
      stock_item_id: "147",
      quantity: "35",
      rate: 400,
      value: 14000,
      total_nos_box: "35"
    },
    grandInwardData: {
      stock_item_id: "147",
      quantity: "55",
      rate: 390,
      value: 21450,
      total_nos_box: "55"
    },
    grandOutwardData: {
      stock_item_id: "147",
      quantity: "45",
      rate: 550,
      value: 24750,
      consumption_value: 17550,
      gross_profit: 7200,
      profit_per: 29.09,
      total_nos_box: "45"
    },
    grandClosingData: {
      stock_item_id: "147",
      quantity: "45",
      rate: 390,
      value: 17550,
      total_nos_box: "45"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "147",
          quantity: "35",
          rate: 400,
          value: 14000,
          total_nos_box: "35"
        },
        grandInwardData: {
          stock_item_id: "147",
          quantity: "55",
          rate: 390,
          value: 21450,
          total_nos_box: "55"
        },
        grandOutwardData: {
          stock_item_id: "147",
          quantity: "45",
          rate: 550,
          value: 24750,
          gross_value: 24750,
          total_nos_box: "45",
          consumption_value: 17550,
          gross_profit: 7200,
          profit_per: 29.09
        },
        grandClosingData: {
          stock_item_id: "147",
          quantity: "45",
          rate: "390.00",
          value: 17550,
          total_nos_box: "45"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Tools",
      item_name: "Wrench Set",
      stock_item_id: "148"
    },
    grandOpeningData: {
      stock_item_id: "148",
      quantity: "25",
      rate: 600,
      value: 15000,
      total_nos_box: "25"
    },
    grandInwardData: {
      stock_item_id: "148",
      quantity: "40",
      rate: 590,
      value: 23600,
      total_nos_box: "40"
    },
    grandOutwardData: {
      stock_item_id: "148",
      quantity: "32",
      rate: 800,
      value: 25600,
      consumption_value: 18880,
      gross_profit: 6720,
      profit_per: 26.25,
      total_nos_box: "32"
    },
    grandClosingData: {
      stock_item_id: "148",
      quantity: "33",
      rate: 590,
      value: 19470,
      total_nos_box: "33"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "148",
          quantity: "25",
          rate: 600,
          value: 15000,
          total_nos_box: "25"
        },
        grandInwardData: {
          stock_item_id: "148",
          quantity: "40",
          rate: 590,
          value: 23600,
          total_nos_box: "40"
        },
        grandOutwardData: {
          stock_item_id: "148",
          quantity: "32",
          rate: 800,
          value: 25600,
          gross_value: 25600,
          total_nos_box: "32",
          consumption_value: 18880,
          gross_profit: 6720,
          profit_per: 26.25
        },
        grandClosingData: {
          stock_item_id: "148",
          quantity: "33",
          rate: "590.00",
          value: 19470,
          total_nos_box: "33"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Tools",
      item_name: "Pliers Set",
      stock_item_id: "149"
    },
    grandOpeningData: {
      stock_item_id: "149",
      quantity: "40",
      rate: 350,
      value: 14000,
      total_nos_box: "40"
    },
    grandInwardData: {
      stock_item_id: "149",
      quantity: "65",
      rate: 340,
      value: 22100,
      total_nos_box: "65"
    },
    grandOutwardData: {
      stock_item_id: "149",
      quantity: "52",
      rate: 480,
      value: 24960,
      consumption_value: 17680,
      gross_profit: 7280,
      profit_per: 29.17,
      total_nos_box: "52"
    },
    grandClosingData: {
      stock_item_id: "149",
      quantity: "53",
      rate: 340,
      value: 18020,
      total_nos_box: "53"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "149",
          quantity: "40",
          rate: 350,
          value: 14000,
          total_nos_box: "40"
        },
        grandInwardData: {
          stock_item_id: "149",
          quantity: "65",
          rate: 340,
          value: 22100,
          total_nos_box: "65"
        },
        grandOutwardData: {
          stock_item_id: "149",
          quantity: "52",
          rate: 480,
          value: 24960,
          gross_value: 24960,
          total_nos_box: "52",
          consumption_value: 17680,
          gross_profit: 7280,
          profit_per: 29.17
        },
        grandClosingData: {
          stock_item_id: "149",
          quantity: "53",
          rate: "340.00",
          value: 18020,
          total_nos_box: "53"
        }
      }
    ]
  },
  {
    stock_item: {
      category_name: "Tools",
      item_name: "Saw Set",
      stock_item_id: "150"
    },
    grandOpeningData: {
      stock_item_id: "150",
      quantity: "20",
      rate: 800,
      value: 16000,
      total_nos_box: "20"
    },
    grandInwardData: {
      stock_item_id: "150",
      quantity: "35",
      rate: 780,
      value: 27300,
      total_nos_box: "35"
    },
    grandOutwardData: {
      stock_item_id: "150",
      quantity: "28",
      rate: 1100,
      value: 30800,
      consumption_value: 21840,
      gross_profit: 8960,
      profit_per: 29.09,
      total_nos_box: "28"
    },
    grandClosingData: {
      stock_item_id: "150",
      quantity: "27",
      rate: 780,
      value: 21060,
      total_nos_box: "27"
    },
    godown_data: [
      {
        location_id: "1",
        location_name: "Main Warehouse",
        grandOpeningData: {
          stock_item_id: "150",
          quantity: "20",
          rate: 800,
          value: 16000,
          total_nos_box: "20"
        },
        grandInwardData: {
          stock_item_id: "150",
          quantity: "35",
          rate: 780,
          value: 27300,
          total_nos_box: "35"
        },
        grandOutwardData: {
          stock_item_id: "150",
          quantity: "28",
          rate: 1100,
          value: 30800,
          gross_value: 30800,
          total_nos_box: "28",
          consumption_value: 21840,
          gross_profit: 8960,
          profit_per: 29.09
        },
        grandClosingData: {
          stock_item_id: "150",
          quantity: "27",
          rate: "780.00",
          value: 21060,
          total_nos_box: "27"
        }
      }
    ]
  }
];
